import React, { useState } from 'react';
import { TextField } from '@material-ui/core';
import { AppColors } from '@lib/common';

interface Props {
  value: number;
  onChange: (value: number | undefined) => void;
  error?: boolean;
  helperText?: React.ReactNode;
  width?: number | string;
  'aria-label'?: string;
  'data-testid'?: string;
}

// Editable numeric cell for use inside DataTable/DataGrid columns.
export const NumberCellInput: React.FC<Props> = ({
  value,
  onChange,
  width,
  'aria-label': ariaLabel,
  ...props
}) => {
  // `value` falls back to the inherited amount when the cell is cleared, so show the typed text while editing.
  const [draft, setDraft] = useState<string | null>(null);

  return (
    <TextField
      type="number"
      value={draft ?? (Number.isFinite(value) ? value : '')}
      onChange={e => {
        const raw = e.target.value;
        setDraft(raw);
        if (raw === '') {
          onChange(undefined);
          return;
        }
        const parsed = parseFloat(raw);
        onChange(isNaN(parsed) ? 0 : parsed);
      }}
      onBlur={() => setDraft(null)}
      onClick={e => e.stopPropagation()}
      inputProps={{
        inputMode: 'numeric',
        step: 'any',
        'aria-label': ariaLabel,
        style: { color: AppColors.DarkBlue, textAlign: 'center' },
      }}
      style={{ width }}
      variant="outlined"
      size="small"
      {...props}
    />
  );
};
